import { Button, Card, CardContent, CardDescription, CardHeader, CardTitle, Clock, LogOut } from "bizpandit-ui";
import { useAuthStore } from "@/stores/authStore";
import { useLogout } from "@/features/auth/hooks/useLogout";

/**
 * Landing page for a User whose `status === "Pending Approval"`. Reached
 * when the root redirect (RoleHomeRedirect) detects that status. The
 * backend already blocks a Pending Approval user from getting a session
 * cookie via login/verify-otp, so hitting this screen typically means
 * either: (a) the browser is holding a stale persisted store from before
 * the backend fix landed, or (b) an admin flipped the account back to
 * Pending Approval mid-session. Either way, "Log out" is the only
 * available action.
 */
export function PendingApprovalPage() {
  const { user } = useAuthStore();
  const logout = useLogout();

  return (
    <div className="flex min-h-screen items-center justify-center bg-surface p-6">
      <Card className="w-full max-w-lg">
        <CardHeader>
          <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-amber-100 text-amber-700">
            <Clock className="h-6 w-6" />
          </div>
          <CardTitle variant="plain">Account pending approval</CardTitle>
          <CardDescription>
            {user?.name ? `Hi ${user.name.split(" ")[0]}, ` : ""}your BizPandit
            account is awaiting an admin's review. You'll be able to sign in
            and access your portal once it's approved. We'll notify you on
            WhatsApp when that happens.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Button
            variant="outline"
            onClick={() => logout.mutate()}
            loading={logout.isPending}
          >
            <LogOut className="mr-2 h-4 w-4" /> Log out
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
